import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UpdatePlaceholderCommand from './updateplaceholdercommand';
import UpdatePlaceholderEditing from './updateplaceholderediting';

export default class UpdatePlaceholder extends Plugin {
    static get pluginName() {
        return 'UpdatePlaceholder';
    }
    static get requires() {
        return [UpdatePlaceholderCommand, UpdatePlaceholderEditing];
    }
}
